module.exports = __webpack_public_path__ + "static/media/check.04fc36a7.svg";